import React from 'react';

const OptionsListItem = ({ name, value, selected, disabled, label, onChange }) => (
  <div>
    <input
      id={`options-list-item-${name}`}
      className="onboarding-selection_input"
      type="checkbox"
      checked={selected}
      disabled={disabled}
      onChange={() => onChange(value)}
    />
    <label
      htmlFor={`options-list-item-${name}`}
      style={{ marginTop: 0 }}
      className="onboarding-selection_label"
    >
      {label}
    </label>
  </div>
);

export default OptionsListItem;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/UI/OptionsList/OptionsListItem.js